import { useEffect } from "react";

import { TenantProfileDto } from "@/core/api/generated/v1";
import { fetchTenantProfile } from "@/store/tenantProfile/slice";

import { useAuthenticationInfo } from "../../auth/useAuthenticationInfo";
import { useAppSelector, useAppThunkDispatch } from "../../redux";
import { useCurrentTenantInfoV2 } from "./useCurrentTenantInfoV2";

/** Returns currently resolved tenant profile (loads it if not loaded). */
export function useTenantProfile(props?: {
  isRefetchOnInit?: boolean;
  isSkipFetch?: boolean;
}): Nil<TenantProfileDto> {
  const dispatch = useAppThunkDispatch();

  const authenticationInfo = useAuthenticationInfo();
  const tenantInfo = useCurrentTenantInfoV2();
  const tenantProfile = useAppSelector((x) => x.tenantProfile.profile);

  useEffect(() => {
    // NB: only fetch if authenticated to avoid unnecessary requests and redirects to login on 401
    if (
      authenticationInfo.isAuthenticated &&
      !tenantProfile &&
      tenantInfo.tenantInfo?.identifier &&
      !props?.isSkipFetch
    ) {
      dispatch(fetchTenantProfile({ isRefetch: props?.isRefetchOnInit }));
    }
  }, [authenticationInfo, tenantInfo, props?.isSkipFetch]);

  return tenantProfile;
}
